import React, { useEffect, useRef, useState } from "react";
import svg66 from "../../assets/svg/svg66.svg";

import { useNavigate } from "react-router-dom";
import LogoSection from "./LogoSection";
function Header({ active, setActive }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const menuItems = [
    { name: "Home", id: "" },
    { name: "Scheme", id: "landing-schemes" },
    { name: "Irrigation Projects", id: "projects" },
    { name: "Map Analysis", id: "map" },
    { name: "Reports", id: "reports" },
    { name: "Investment Calculator", id: "InvestmentCalculator" }, 
    
  ];

  const navigate = useNavigate();
  const handleClick = (id) => {
    // navigate(`/${id}`);
    setActive(id);
    setMenuOpen(false);
    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef?.current?.contains(event?.target)) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) {
      document?.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document?.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="fixed top-0 left-0 right-0 w-full z-[9999]">
      <LogoSection />
      <div
        className={`px-4 lg:px-[6.25rem]  flex items-center justify-between w-full
            transition-all duration-300  bg-[#637381] text-white py-[1rem]`}
      >
        <img className="" src={svg66} alt="search" />

        <div
          className="lg:hidden flex justify-end cursor-pointer w-full"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 6L6 18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 7H21C21.2652 7 21.5196 6.89464 21.7071 6.70711C21.8946 6.51957 22 6.26522 22 6C22 5.73478 21.8946 5.48043 21.7071 5.29289C21.5196 5.10536 21.2652 5 21 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6C2 6.26522 2.10536 6.51957 2.29289 6.70711C2.48043 6.89464 2.73478 7 3 7ZM21 17H3C2.73478 17 2.48043 17.1054 2.29289 17.2929C2.10536 17.4804 2 17.7348 2 18C2 18.2652 2.10536 18.5196 2.29289 18.7071C2.48043 18.8946 2.73478 19 3 19H21C21.2652 19 21.5196 18.8946 21.7071 18.7071C21.8946 18.5196 22 18.2652 22 18C22 17.7348 21.8946 17.4804 21.7071 17.2929C21.5196 17.1054 21.2652 17 21 17ZM21 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H21C21.2652 15 21.5196 14.8946 21.7071 14.7071C21.8946 14.5196 22 14.2652 22 14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM21 9H3C2.73478 9 2.48043 9.10536 2.29289 9.29289C2.10536 9.48043 2 9.73478 2 10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10C22 9.73478 21.8946 9.48043 21.7071 9.29289C21.5196 9.10536 21.2652 9 21 9Z"
                fill="black"
              />
            </svg>
          )}
        </div>

        <div>
          <ul
            ref={menuRef}
            className={`${
              menuOpen ? "flex z-[9999] bg-white" : "hidden"
            } transition-all duration-300 absolute top-full left-0 w-full flex-col items-start gap-y-4 px-6 py-4 lg:flex lg:static lg:flex-row lg:items-center lg:gap-x-[2rem] `}
          >
            {menuItems.map((item) => (
              <li
                key={item.id}
                onClick={() => handleClick(item.id)}
                className={`cursor-pointer transition-colors duration-200 hover:text-[#F7D9A8] ${
                  active === item.id
                    ? "text-[#F7D9A8] underline"
                    : "text-black1 lg:text-white"
                } ${scrolled && active === item.id && "lg:text-[#F7D9A8]"} `}
              >
                {item.name}
              </li>
            ))}
            <div className="lg:hidden block">
              <button
                className={`rounded-[.375rem] border border-[#D6E1F5] bg-white py-[.3rem] px-[.75rem] flex
              justify-center items-center text-[.75rem] text-[#1A1A1A] font-[400] font-sora`}
                type="submit"
                onClick={() => navigate("/login")}
              >
                Sign In
              </button>
            </div>
          </ul>
        </div>

        <div className="lg:block hidden">
          {" "}
          <button
            className={`rounded-[.375rem] border border-[#D6E1F5] bg-white py-[.3rem] px-[.75rem] flex
             justify-center items-center text-[.75rem] text-[#1A1A1A] font-[400] font-sora`}
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;
